import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Users, UserCheck, Wallet, TrendingUp } from 'lucide-react';

const actions = [
  { href: '/workers', label: 'Add Worker', icon: Users, color: 'text-[#2E4632]', testId: 'quick-action-workers' },
  { href: '/attendance', label: 'Mark Attendance', icon: UserCheck, color: 'text-[#2E4632]', testId: 'quick-action-attendance' },
  { href: '/advances', label: 'Give Advance', icon: Wallet, color: 'text-[#D97706]', testId: 'quick-action-advances' },
  { href: '/reports', label: 'View Reports', icon: TrendingUp, color: 'text-[#2E4632]', testId: 'quick-action-reports' }
];

export const QuickActions = () => (
  <Card className="bg-white border border-[#D1D1CD] rounded-lg shadow-sm">
    <CardHeader>
      <CardTitle className="text-xl font-semibold text-[#1C1C1E]" style={{ fontFamily: 'Manrope, sans-serif' }}>
        Quick Actions
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {actions.map((action) => (
          <a
            key={action.href}
            href={action.href}
            data-testid={action.testId}
            className="flex flex-col items-center p-4 rounded-lg bg-[#F4F4F0] hover:bg-[#E8E8E3] transition-colors touch-target"
          >
            <action.icon className={`w-8 h-8 ${action.color} mb-2`} />
            <span className="text-sm font-medium text-[#1C1C1E]">{action.label}</span>
          </a>
        ))}
      </div>
    </CardContent>
  </Card>
);
